import { all, call, put, takeLatest } from 'redux-saga/effects';

import { showAlertBanner } from '@dragonfruit/redux/alertBanner';
import { ALERT_ERROR_THEME } from '@dragonfruit/constants/alertBannerThemes';
import * as actions from '@dragonfruit/redux/purchase/braintreeSetup';
import {
  apiFetchBTClientToken,
  apiFetchBTPaymentMethodTokens,
} from '@dragonfruit/services/apis';
import { home } from '@dragonfruit/redux/navigation';
import { actions as errorActions } from '@dragonfruit/redux/error';

export function* fetchBraintreeClientToken() {
  try {
    const response = yield call(apiFetchBTClientToken);

    yield put(
      actions.fetchBraintreeClientTokenSuccess(response.data.clientToken)
    );
  } catch (err) {
    yield put(
      showAlertBanner({
        message: err.message,
        theme: ALERT_ERROR_THEME,
      })
    );
    yield put(actions.fetchBraintreeClientTokenError(err.message));
    yield put(home());
  }
}

export function* fetchPaymentMethodTokens() {
  try {
    const response = yield call(apiFetchBTPaymentMethodTokens);
    const { data: { creditCards: allCreditCards } = {} } = response;

    // Final list of credit cards we'll display
    const filteredCreditCards = [];

    // Using a map to handle unique cards
    const alreadyExistsMap = {};

    const allCreditCardsLength = allCreditCards.length;

    if (allCreditCardsLength) {
      for (let i = 0; i < allCreditCardsLength; i++) {
        const currentCard = allCreditCards[i];
        // If the current card (last_4) exists in map
        // we continue to the next iteration
        // the backend response is pre-sorted
        // so this logic works fine.
        if (alreadyExistsMap[currentCard.last4]) {
          continue;
        }
        alreadyExistsMap[currentCard.last4] = true;
        filteredCreditCards.push(currentCard);
      }
    }

    yield put(actions.fetchPaymentMethodTokenSuccess(filteredCreditCards));
  } catch (err) {
    yield put(actions.fetchPaymentMethodTokenError(err.message));
    yield put(errorActions.sendError(err));
  }
}

export default function*() {
  yield all([
    takeLatest(actions.FETCH_BRAINTREE_CLIENT_TOKEN, fetchBraintreeClientToken),
    takeLatest(actions.FETCH_PAYMENT_METHOD_TOKEN, fetchPaymentMethodTokens),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/purchase/braintreeSetup.js